// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-footer----footer-module---wrapper---3e89s","container":"src-components-footer----footer-module---container---1-vt1","navigation":"src-components-footer----footer-module---navigation---1ugUX","award":"src-components-footer----footer-module---award---3IsM6","awards":"src-components-footer----footer-module---awards---2k16r","awardHome":"src-components-footer----footer-module---awardHome---373CA","menuInfo":"src-components-footer----footer-module---menuInfo---3861Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.module.css
// module id = 164
// module chunks = 35783957827783 114276838955818